/* Occasion Reminder — client-side calendar (.ics) + WhatsApp helpers.
   No backend required: the customer gets a guaranteed reminder in their own
   calendar, and the store owner receives the saved occasion via the Shopify
   contact form. */
(function () {
  'use strict';

  function pad(n) {
    return String(n).length < 2 ? '0' + n : String(n);
  }

  // Format a Date as an all-day iCalendar date value (YYYYMMDD).
  function toIcsDate(date) {
    return date.getFullYear() + pad(date.getMonth() + 1) + pad(date.getDate());
  }

  // Format "now" as a UTC timestamp for DTSTAMP (YYYYMMDDTHHMMSSZ).
  function toIcsStamp(date) {
    return (
      date.getUTCFullYear() +
      pad(date.getUTCMonth() + 1) +
      pad(date.getUTCDate()) +
      'T' +
      pad(date.getUTCHours()) +
      pad(date.getUTCMinutes()) +
      pad(date.getUTCSeconds()) +
      'Z'
    );
  }

  // iCalendar requires escaping of , ; \ and newlines in text values.
  function escapeText(value) {
    return String(value)
      .replace(/\\/g, '\\\\')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,')
      .replace(/\r?\n/g, '\\n');
  }

  function buildIcs(fields) {
    var occasionDate = new Date(fields.date + 'T09:00:00');
    if (isNaN(occasionDate.getTime())) return null;

    // All-day event on the occasion; end date is the next day per RFC 5545.
    var nextDay = new Date(occasionDate.getTime());
    nextDay.setDate(nextDay.getDate() + 1);

    var summary =
      (fields.occasion || 'Gift reminder') +
      (fields.recipient ? ' — ' + fields.recipient : '');
    var description =
      'Time to send a gift from Giftogram by Samana. ' +
      'Order early for same-day delivery in Karachi. Shop: ' +
      fields.shopUrl;

    var uid =
      'occasion-' +
      Date.now() +
      '-' +
      Math.random().toString(36).slice(2) +
      '@giftogrambysamana.com';

    var lines = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Giftogram by Samana//Occasion Reminder//EN',
      'CALSCALE:GREGORIAN',
      'METHOD:PUBLISH',
      'BEGIN:VEVENT',
      'UID:' + uid,
      'DTSTAMP:' + toIcsStamp(new Date()),
      'DTSTART;VALUE=DATE:' + toIcsDate(occasionDate),
      'DTEND;VALUE=DATE:' + toIcsDate(nextDay),
      'SUMMARY:' + escapeText(summary),
      'DESCRIPTION:' + escapeText(description),
      'BEGIN:VALARM',
      'ACTION:DISPLAY',
      'DESCRIPTION:' + escapeText(summary + ' is coming up — order a gift now'),
      // First reminder 7 days before the occasion.
      'TRIGGER:-P7D',
      'END:VALARM',
      'BEGIN:VALARM',
      'ACTION:DISPLAY',
      'DESCRIPTION:' + escapeText(summary + ' is in 2 days — last chance to order'),
      // Second reminder 2 days before the occasion.
      'TRIGGER:-P2D',
      'END:VALARM',
      'END:VEVENT',
      'END:VCALENDAR'
    ];

    return lines.join('\r\n');
  }

  function readFields(root) {
    return {
      recipient: (root.querySelector('[data-or-recipient]') || {}).value || '',
      occasion: (root.querySelector('[data-or-occasion]') || {}).value || '',
      date: (root.querySelector('[data-or-date]') || {}).value || '',
      shopUrl: root.getAttribute('data-shop-url') || window.location.origin
    };
  }

  function validate(root, fields) {
    var error = root.querySelector('[data-or-error]');
    var missing = !fields.date || !fields.occasion;
    if (error) error.hidden = !missing;
    return !missing;
  }

  function downloadIcs(fields) {
    var content = buildIcs(fields);
    if (!content) return;
    var blob = new Blob([content], { type: 'text/calendar;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    var safeName = (fields.occasion || 'occasion')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
    link.href = url;
    link.download = 'giftogram-reminder-' + (safeName || 'occasion') + '.ics';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 1000);
  }

  // Fire-and-forget POST of the saved occasion to an optional external endpoint
  // (e.g. a Google Apps Script web app) so the store can auto-remind the
  // customer before the date. Uses sendBeacon so it survives the form's native
  // navigation; falls back to a keepalive fetch when sendBeacon is unavailable.
  function sendToEndpoint(root) {
    var endpoint = root.getAttribute('data-endpoint');
    if (!endpoint) return;

    var value = function (name) {
      var el = root.querySelector('[name="' + name + '"]');
      return el ? el.value : '';
    };

    var data = new FormData();
    data.append('name', value('contact[Your name]'));
    data.append('email', value('contact[email]'));
    data.append('phone', value('contact[WhatsApp / Phone]'));
    data.append('recipient', value('contact[Recipient]'));
    data.append('occasion', value('contact[Occasion]'));
    data.append('date', value('contact[Occasion date]'));
    data.append('shopUrl', root.getAttribute('data-shop-url') || '');

    try {
      if (navigator.sendBeacon && navigator.sendBeacon(endpoint, data)) return;
    } catch (e) {
      /* fall through to fetch */
    }
    try {
      fetch(endpoint, { method: 'POST', body: data, mode: 'no-cors', keepalive: true });
    } catch (e) {
      /* best-effort only; the Shopify contact email is the source of truth */
    }
  }

  function openWhatsApp(root, fields) {
    var wa = root.getAttribute('data-wa');
    if (!wa) return;
    var msg =
      'Hi! Please remind me about this occasion: ' +
      (fields.occasion || '') +
      (fields.recipient ? ' for ' + fields.recipient : '') +
      ' on ' +
      fields.date +
      '. I would like to send a gift.';
    window.open(
      'https://wa.me/' + wa + '?text=' + encodeURIComponent(msg),
      '_blank',
      'noopener'
    );
  }

  function init(root) {
    if (root.dataset.orReady) return;
    root.dataset.orReady = 'true';

    var form = root.querySelector('form');
    var calBtn = root.querySelector('[data-or-calendar]');
    var waBtn = root.querySelector('[data-or-whatsapp]');

    // Tapping anywhere on a date field opens the native date picker. On mobile
    // the native tap already does this; showPicker() makes the whole field a
    // target on desktop too, so the tiny calendar icon isn't the only way in.
    var dateInputs = root.querySelectorAll('input[type="date"]');
    for (var d = 0; d < dateInputs.length; d++) {
      dateInputs[d].addEventListener('click', function () {
        if (typeof this.showPicker === 'function') {
          try {
            this.showPicker();
          } catch (e) {
            /* showPicker needs a user gesture; the click is one, ignore edge cases */
          }
        }
      });
    }

    // On a real save, also log the occasion to the optional endpoint. We don't
    // block Shopify's native submit — the beacon is sent alongside it.
    if (form) {
      form.addEventListener('submit', function () {
        sendToEndpoint(root);
      });
    }

    if (calBtn) {
      calBtn.addEventListener('click', function () {
        var fields = readFields(root);
        if (validate(root, fields)) downloadIcs(fields);
      });
    }

    if (waBtn) {
      waBtn.addEventListener('click', function () {
        var fields = readFields(root);
        if (validate(root, fields)) openWhatsApp(root, fields);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-occasion-reminder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', initAll);
})();
